import * as React from "react";


import * as LF from "leaflet";
import 'leaflet/dist/leaflet.css'

import Highcharts from "highcharts";

import highchartsMap from "highcharts/modules/map";
import HighchartsReact from "highcharts-react-official";
import {ProjectsService} from "../../service/v1/projects";
import Wait from "../wait";
import GeneralSelect from "../general_select";
import SecondLayer from "../container/second_layer";
import ProjectContainer from "../v1/project/project_container";
import uncheck from "../../resources/img/checkbox/checkbox_unchecked.png";


import { CollectService } from "../../service/v1/collect";

highchartsMap(Highcharts); // Initialize the map module

const fontFamily = 'Poppins, Inter, Open Sans, Helvetica, Arial, sans-serif';
const cardStyle = {
    background: '#fff',
    borderRadius: 8,
    boxShadow: '0 1px 4px rgba(0,0,0,0.04)',
    padding: '18px 12px',
    margin: '8px 0',
    minWidth: 0,
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 90,
    fontFamily
};

const cardTitleStyle = {
    fontWeight: 600,
    fontSize: 16,
    marginBottom: 4,
    color: '#395d9a',
    textAlign: 'center',
    fontFamily
};

const cardCountStyle = {
    fontSize: 28,
    fontWeight: 700,
    color: '#222',
    textAlign: 'center',
    fontFamily
};

const flexRow = {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 16,
    margin: '0 0 16px 0',
    width: '100%',
    fontFamily
};

const flexCol = {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    width: '100%',
    fontFamily
};

const chartCardStyle = {
    ...cardStyle,
    minHeight: 320,
    flex: 2,
    alignItems: 'stretch',
    padding: 0,
    fontFamily
};

const expiryCardStyle = {
    ...cardStyle,
    minHeight: 320,
    flex: 1,
    alignItems: 'stretch',
    padding: '18px 12px',
    fontSize: 16,
    fontFamily
};

const nationalOption = {
    chart: {
        renderTo: 'high-chart-donut0',
        type: 'pie'
    },
    title: {
        text: 'Total Area per Land Use Plan'
    },
    yAxis: {
        title: {
            text: 'Total percent market share'
        }
    },
    plotOptions: {
        pie: {
            shadow: true
        }
    },
    tooltip: {
        formatter: function () {
            return '<b>' + this.point.name + '</b>: ' + this.y + ' %';
        }
    },
    series: [{
        name: 'LandUse',
        data: [["Agriculture", 40], ["Settlement", 30], ["Forest", 10], ["Investment", 15], ["Reserve", 5]],
        size: '100%',
        innerSize: '10%',
        showInLegend: true,
        dataLabels: {
            enabled: true
        }
    }]
}


const nationalOptionBar = {
    chart: {
        type: 'column'
    },

    title: {
        text: 'Number of Projects Per Funder'
    },

    subtitle: {
        text: ''
    },

    yAxis: {
        title: {
            text: 'No. of Project'
        }
    },

    xAxis: {
        categories: ['Funder'],
        crosshair: true
    },

    legend: {
        layout: 'vertical',
        align: 'right',
        verticalAlign: 'middle'
    },

    /* plotOptions: {
         series: {
             label: {
                 connectorAllowed: false
             },
             /!*pointStart: 2013*!/
         }
     },
*/
    series: [
        {name: 'NGO', data: [2]},
        {name: 'Government', data: [1]}
    ],
    /* series: ,*/

    responsive: {
        rules: [{
            condition: {
                maxWidth: 500
            },
            chartOptions: {
                legend: {
                    layout: 'horizontal',
                    align: 'center',
                    verticalAlign: 'bottom'
                }
            }
        }]
    }
}


export default class DashboardPane extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            current_dashboard: <div>Loading...</div>,
            project_data: {
                total: '',
                approved: '',
                ongoing: '',
                active: '',
                expiry: '',
                // ccroCount: ''
            },
            ccroCount: 0,
            projectOptions: {
                endpoint: `projects/project-types`,
                value: 'id',
                label: 'name',
                placeholder: 'Select Project'
            },
        }
        DashboardPane.self = this
        this.projectStats = this.projectStats.bind(this)
        this.getBarOption = this.getBarOption.bind(this)
        this.generalSelect = this.generalSelect.bind(this)

        this.fetchCcroStats = this.fetchCcroStats.bind(this)
    }

    componentDidMount() {
        //this.fetchCharts()
        this.projectStats()
        this.fetchCcroStats();
        let localityLevel = JSON.parse(sessionStorage.getItem('decoded')).locality.level
        console.log('HAPA [[ ')
        console.log(localityLevel)
    }
 
    // fetchCcroStats() {
    //     CollectService.fetchCcroCounter().then(r => {
    //         try {
    //             this.setState(prevState => ({
    //                 project_data: {
    //                     ...prevState.project_data,
    //                     ccroCount: r.data.count || 0
    //                 }
    //             }))
    //         } catch (e) {
    //             console.error('Error updating CCRO count:', e)
    //         }
    //     })
    // }


    fetchCcroStats() {
        CollectService.fetchCcroCounter().then(r => {
            try {
                const ccroCount = r.data.count || 0;
                // Store in localStorage
                localStorage.setItem('ccroCount', ccroCount);
                this.setState({
                    ccroCount: ccroCount
                })
            } catch (e) {
                console.error('Error updating CCRO count:', e)
            }
        })
    }
    
    
  

    handleChanges = (e) => {
        this.setState({[e.target.name]: e.target.value})
        console.log(e.target.value)
    }

    projectStats(project_type_id = null) {
        if (project_type_id === null) {
            ProjectsService.fetchProjectStats().then(r => {
                try {
                    this.setState({
                        project_data: {
                            total: r.data.results.stats.projects.total,
                            approved: r.data.results.stats.projects.approved,
                            ongoing: r.data.results.stats.projects.ongoing,
                            active: r.data.results.stats.projects.active,
                            expiry: r.data.results.stats.projects.expiry,
                            funders: r.data.results.funders,
                            toExpire: [...r.data.results.toExpire],
                        },
                    })
                } catch (e) {
                    console.log(e)
                }
            })
        } else {
            ProjectsService.fetchProjectStatsByType(project_type_id).then(r => {
                try {
                    this.setState({
                        project_data: {
                            total: r.data.results.stats.projects.total,
                            approved: r.data.results.stats.projects.approved,
                            ongoing: r.data.results.stats.projects.ongoing,
                            active: r.data.results.stats.projects.active,
                            expiry: r.data.results.stats.projects.expiry,
                            funders: r.data.results.funders,
                            toExpire: [...r.data.results.toExpire],
                        },
                    })
                } catch (e) {
                    console.log(e)
                }
            })
        }
    }

    generalSelect(data, name) {
        this.setState({
            [name]: data
        })
        this.projectStats(data.value)
        console.log(data.value)
    }

    render() {
        console.log('Funders 0 ')
        console.log(this.state.project_data)
        let localityLevel = JSON.parse(sessionStorage.getItem('decoded')).locality
        return (<div id={'dashboard_content'}
                     style={{padding: '24px', height: '95%', marginRight: '4px', overflowY: 'auto', fontFamily}}>

            <div className={'row'}>
                <div className={'col col-sm-3'}>
                        <div>
                            <GeneralSelect onChanges={(e) => this.generalSelect(e, 'project_type')}
                                           parameters={this.state.projectOptions} defaultValue={5}/>

                        </div>
                </div>
            </div>
            <div className={'row'} style={{marginTop: '16px'}}>
                <div className={'col col-sm-2'}>
                    <div className={'ucard'} style={{borderBottom: '2px solid #f0f'}}>
                        <div id={'title'}><b>Total Land Use Plans</b></div>
                        <div id={'count'}>{this.state.project_data.total}</div>
                    </div>
                </div>
                <div className={'col col-sm-2'}>
                    <div className={'ucard'} style={{borderBottom: '2px solid #fb0'}}>
                        <div id={'title'}>On Going Land Use Plans</div>
                        <div id={'count'}>{this.state.project_data.approved}</div>
                    </div>
                </div>

                <div className={'col col-sm-2'}>
                    <div className={'ucard'} style={{borderBottom: '2px solid darkcyan'}}>
                        <div id={'title'}>Active Land Use Plans</div>
                        <div id={'count'}>{this.state.project_data.active}</div>
                    </div>
                </div>
                <div className={'col col-sm-2'}>
                    <div className={'ucard'} style={{borderBottom: '2px solid #f00'}}>
                        <div id={'title'}>Expired or Close to Expiry</div>
                        <div id={'count'}>{this.state.project_data.expiry}</div>
                    </div>
                </div>
                <div className={'col col-sm-2'}>
                    <div className={'ucard'} style={{borderBottom: '2px solid #f0f'}}>
                        <div id={'title'}><b>Total Land Use Plans</b></div>
                        <div id={'count'}>{this.state.project_data.total}</div>
                    </div>
                </div>
                <div className={'col col-sm-2'}>
                    <div className={'ucard'} style={{borderBottom: '2px solid #f0f'}}>
                        <div id={'title'}><b>CCRO Counter</b></div>
                        <div id={'count'}>
                              {this.state.ccroCount || localStorage.getItem('ccroCount') || 0}
                        </div>
                        
                        {/* <div id={'count'}>{this.state.project_data.ccroCount}</div> */}
                    </div>
                </div>
            </div>
            
            
          
               


            <div className={'row'} style={{marginTop: '16px'}}>
                <div className={'col col-sm-8'}>
                    <div className={'ucard'} style={{borderBottom: '2px solid darkcyan', height: 'fit-content'}}
                         id={'high-chart-bar'}>
                        <HighchartsReact
                            highcharts={Highcharts}
                            options={this.getBarOption(this.state.project_data.funders)}
                        />
                    </div>
                </div>
                <div className={'col col-sm-4'}>
                    <div className={'ucard'}
                         style={{borderBottom: '2px solid #f00', height: 'fit-content', fontSize: '18px'}}>
                        <div style={{fontSize: '23px'}}>Land use plans that are about to expire</div>

                        {this.state.project_data.toExpire !== undefined ?
                            this.state.project_data.toExpire.map((d, i) => {
                            return (
                                <div id={'title'}>{d.project}</div>
                            )
                        })
                            : <div></div>
                        }
                    </div>
                </div>
            </div>
            {/*{this.state.current_dashboard}*/}

        </div>)
    }


    getBarOption(funders = []) {
        let series = []
        funders.map((d, i) => {
            let entry = {name: d.funder, data: [Number(d.projects)]}
            series.push(entry)
        })
        console.log(series)
        return {
            chart: {
                type: 'column'
            },

            title: {
                text: 'Land Use Plan per Funder'
            },

            subtitle: {
                text: ''
            },

            yAxis: {
                title: {
                    text: 'Funder'
                }
            },

            xAxis: {
                categories: ['Land Use'],
                crosshair: true
            },

            legend: {
                layout: 'vertical',
                align: 'right',
                verticalAlign: 'middle'
            },

            /* plotOptions: {
                 series: {
                     label: {
                         connectorAllowed: false
                     },
                     /!*pointStart: 2013*!/
                 }
             },
 */
            series: series,
            /* series: ,*/

            responsive: {
                rules: [{
                    condition: {
                        maxWidth: 500
                    },
                    chartOptions: {
                        legend: {
                            layout: 'horizontal',
                            align: 'center',
                            verticalAlign: 'bottom'
                        }
                    }
                }]
            }
        }
    }


}
         